import { useQuery } from '@tanstack/react-query'
import { apiInstance } from 'services/api'
import { useMasquaradeToken } from 'services/masquarade/masquarade.hooks'
import { useAccessToken } from 'services/token/token.hooks'
import type { LeaseContractResponse } from 'services/contracts/hooks/useLeaseContracts'
import { useTermsOfUse } from 'services/terms/terms.hooks'

export interface LeaseContractsManagementCompanyResponse {
  id: number
  addressCity: string
  addressStreet: string
  addressZipcode: string
  name: string
}

export const useLeaseContractsManagementCompany = (id?: LeaseContractResponse['id']) => {
  const { accessToken } = useAccessToken()
  const { masquaradeToken } = useMasquaradeToken()
  const { hasUserConsented } = useTermsOfUse()

  const { data: leaseContractsManagementCompany, ...rest } = useQuery({
    queryKey: ['leaseContractsManagementCompany', id, masquaradeToken],
    queryFn: () =>
      apiInstance<LeaseContractsManagementCompanyResponse>({
        url: `/lease/contracts/${id}/management-company/`,
        method: 'GET',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'mask-authorization': !!masquaradeToken ? `Token ${masquaradeToken}` : undefined
        }
      }).then(({ data }) => data),
    enabled: !!accessToken && !!id && hasUserConsented
  })

  return { leaseContractsManagementCompany, ...rest }
}
